import React from "react"
import SmartLink from "../../../../layout/SmartLink/SmartLink"
import { CHOOSE_THE_RIGHT_CARE_HOME_URL } from "../../../../../utils/paths"
import { InlineText } from "../../../../Typography/Typography"

const faqLinkClickEvent = {
  name: "SEO - Filtered Directory - FAQs External Link Clicked",
}

export default () => (
  <SmartLink to={CHOOSE_THE_RIGHT_CARE_HOME_URL} clickEvent={faqLinkClickEvent}>
    <InlineText brand>how to choose the right care home</InlineText>
  </SmartLink>
)
